// Runs synchronously in <head> — sets data-theme and has-session on <html>
// before the first paint to prevent white flash and header CLS.
// Must stay tiny: no DOM access beyond document.documentElement.
(function () {
  try {
    var query = new URLSearchParams(window.location.search || '');
    var path = window.location.pathname || '/';
    var isHomePath = path === '/' || path === '/index.html';
    var hash = window.location.hash ? window.location.hash.replace(/^#/, '') : '';
    if (isHomePath && hash) {
      var authErrorParams = new URLSearchParams(hash);
      if (authErrorParams.get('error') || authErrorParams.get('error_code')) {
        window.location.replace('/confirm-email' + (window.location.search || '') + window.location.hash);
        return;
      }
    }

    var forcedTheme = query.get('theme');
    var t = (forcedTheme === 'dark' || forcedTheme === 'light')
      ? forcedTheme
      : (localStorage.getItem('theme') ||
        (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'));
    document.documentElement.setAttribute('data-theme', t);

    var proposal = query.get('proposal');
    var supportedProposals = {
      'briefing-desk': true,
      'research-ledger': true,
      'policy-dispatch': true
    };
    if (proposal && supportedProposals[proposal]) {
      document.documentElement.setAttribute('data-proposal', proposal);
    } else {
      document.documentElement.removeAttribute('data-proposal');
    }

    if (localStorage.getItem('sb-bvofbtvxgwzhqjstitij-auth-token')) {
      document.documentElement.classList.add('has-session');
    }
  } catch (e) {}
}());
